import React from 'react'
import Header1 from '../components/Header1'
import Footer from '../components/Footer'
import HowEnterpriseWillBuildPredictableGrowth from '../components/HowEnterpriseWillBuildPredictableGrowth'

export default function HowEnterprisesWillBuildPredictableGrowthInAnUncertainMarket() {
  return (
    <div>
      <Header1/>
    <HowEnterpriseWillBuildPredictableGrowth/>
      <Footer/>
    </div>
  )
}
